import { z } from "zod";
import { deviceLocationSchema } from "./deviceLocationSchema";

export const deviceMeasurementSchema = z.strictObject({
  secondsSincePowerOn: z
    .uint32()
    .describe(
      "The time since power-on that the report was generated, in seconds",
    ),
  temperatureC: z.number().describe("The temperature in degrees Celsius"),
  relativeHumidity: z
    .number()
    .min(0)
    .max(100)
    .describe("The relative humidity, 0-100%"),
  batterymV: z.uint32().describe("Current battery voltage in millivolts"),
  location: deviceLocationSchema
    .optional()
    .describe(
      "The location of the device when the measurement was taken, if available",
    ),
  weights: z
    .array(z.number().nullable())
    .describe(
      "Array of raw weight readings, one per sensor. Calibration and conversion to kg is done on the server",
    ),
});

export type DeviceMeasurement = z.infer<typeof deviceMeasurementSchema>;
